module.exports = __webpack_public_path__ + "img/logo_no_bg_black.944c9caf.svg";